import React from "react";
import { useDispatch } from "react-redux";

import { toggleSelectedItem } from "reducers/Selected";
import { useShiftClick } from "hooks/useShiftClick";

import "./SelectCell.css";

export function SelectItem({ props, dependentValues }){
	let dispatch = useDispatch();
	const { checkboxId, id, type, isSelected, shiftSelectConfig = {} } = dependentValues;
	let shiftClick = useShiftClick(id, type, shiftSelectConfig);


	return (
		<label
			className="select-holder"
			onMouseDown={shiftClick}
		>
			<input
				type="checkbox"
				className="custom-checkbox"
				name="select-row"
				checked={isSelected}
				id={checkboxId}
				onChange={(evt) => {
					if(evt.nativeEvent.shiftKey){ return; }
					dispatch(toggleSelectedItem(id, type, evt.target.checked));
				}}
			/>
			<span className="pretty-checkbox" />
		</label>
	);
}

const SelectCell = {
	key:"selected",
	name:"",
	cellClass:"select-cell",
	locked:true,
	resizable:false,
	sortable:false,
	width:40,
	formatter:SelectItem,
};

export default SelectCell;
